import * as Yup from 'yup'

export const validationSchema = Yup.object({
    name: Yup.string().max(50, 'Name must be less than 50 characters').required('Portfolio Name is required'),
    isCounterparty: Yup.boolean().required('Type is required'),
    location: Yup.string().max(25, 'Location must be less than 25 characters'),
    description: Yup.string().max(80, 'Description must be less than 80 characters'),
})
